import { useMagasinStore } from "@/store/magasin";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const pageInfosEtServicesProspectusProps = () => ({
  prospectus: {
    type: Array,
    required: true
  }
})

export const usePageInfosEtServicesProspectus = () => {
  const { isNational } = storeToRefs(useMagasinStore());

  const { trackEvent } = useInteractionDoneTracking();

  const socialMediaLinkClicked = (app) => {
    trackEvent({
      categoryGA: trackingCodes.PAGETYPE.prospectus,
      actionGA: trackingCodes.ACTIONGA.socialMedia,
      labelGA: app
    });
  }

  return { isNational, socialMediaLinkClicked }
}